module.exports = __webpack_public_path__ + "static/media/mt.d223127a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/countriesFlags/mt.svg
// module id = 1461
// module chunks = 0